export default "<p>footer works!</p>\r\n"